/** Format / parse KES sum-insured inputs with thousands separators (e.g. 1,000,000). */

export function parseKesAmount(value) {
  if (value == null || value === '') return NaN;
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
  const cleaned = String(value).replace(/,/g, '').replace(/[^\d.]/g, '').trim();
  if (!cleaned) return NaN;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
}

export function formatKesAmountInput(value) {
  const n = parseKesAmount(value);
  if (!Number.isFinite(n) || n < 0) {
    const digits = String(value || '').replace(/[^\d]/g, '');
    if (!digits) return '';
    const asNum = Number(digits);
    return Number.isFinite(asNum) ? asNum.toLocaleString('en-KE') : '';
  }
  return Math.round(n).toLocaleString('en-KE');
}

export function formatKesDisplay(value) {
  const n = parseKesAmount(value);
  if (!Number.isFinite(n)) return '—';
  return Math.round(n).toLocaleString('en-KE');
}
